/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import App from './App';
import common_pt from './translations/pt-br/common.json';
import common_en from './translations/en/common.json';
import common_es from './translations/es/common.json';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'pt',
  fallbackLng: 'pt', // Fallback para português se o idioma não for encontrado
  react: {
    useSuspense: false,
  },
  resources: {
    pt: {
      common: common_pt,
    },
    en: {
      common: common_en,
    },
    es: {
      common: common_es, // 'common' is our custom namespace
    },
  },
});

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .register('./firebase-messaging-sw.js')
//     .then(function (registration) {
//       konsole.log('Registration successful, scope is:', registration.scope);
//     })
//     .catch(function (err) {
//       konsole.log('Service worker registration failed, error:', err);
//     });
// }

async function loadConfigAndStartApp() {
  try {
    await loadGlobalConfig();

    i18next.init({
      interpolation: { escapeValue: false },
      lng: 'pt',
      fallbackLng: 'pt',
      react: { useSuspense: false },
      resources: {
        pt: { common: common_pt },
        en: { common: common_en },
        es: { common: common_es },
      },
    });

    ReactDOM.render(
      <React.StrictMode>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider>
      </React.StrictMode>,
      document.getElementById('root')
    );
  } catch (error) {
    console.error('Erro ao carregar config.js:', error);
  }
}

function loadGlobalConfig() {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '/envconfig.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Erro ao carregar config.js'));
    document.head.appendChild(script);
  });
}

loadConfigAndStartApp();